// ================= PROD =================
export const base_url = "https://api.smindia2050.com/api/";
export const img_url = "https://api.smindia2050.com/";
export const socket_url = "https://api.smindia2050.com/";
export const deposit_socket_url = "https://api.smindia2050.com/";
export const audio_url = "https://api.smindia2050.com/";

// ================= DEV =================
// export const base_url = "https://dev-api.smindiagroup.com/api/";
// export const img_url = "https://dev-api.smindiagroup.com/";
// export const socket_url = "https://dev-api.smindiagroup.com/";
// export const deposit_socket_url = "https://dev-api.smindiagroup.com/";
// export const audio_url = "https://dev-api.smindiagroup.com/";

// ================= LOCAL =================
// export const base_url = "http://localhost:5000/api/";
// export const img_url = "http://localhost:5000/";
// export const socket_url = "http://localhost:5000/";
// export const deposit_socket_url = "http://localhost:5000/";
// export const audio_url = "http://localhost:5000/";
